export default __webpack_public_path__ + "static/media/kitchen3-after1-1440w.b9de4a2f.avif";